import { ENDPOINTS } from "../services/Endpoints";
export default {
  data() {
    return {
      ENDPOINTS: ENDPOINTS,
      headers: [
        {
          text: "Ponto de Venda",
          align: "center",
          sortable: true,
          value: "representante_nome",
          width: 150,
        },
        {
          text: "Representante",
          align: "center",
          sortable: true,
          value: "representante_nome",
          width: 100,
        },
        {
          text: "Data do cadastro",
          align: "center",
          sortable: true,
          value: "ins_dthr",
        },
        {
          text: "Tipo de Pessoa",
          align: "center",
          sortable: true,
          value: "tipo_pessoa",
          width: 150,
        },
        {
          text: "CPF/CNPJ",
          align: "center",
          sortable: true,
          value: "representante_cpf",
          width: 150,
        },
        {
          text: "E-mail",
          align: "center",
          sortable: true,
          value: "representante_email",
        },
        {
          text: "Status",
          align: "center",
          sortable: true,
          value: "status",
          width: 150,
        },
        {
          text: "Ações",
          align: "center",
          sortable: false,
          value: "actions",
          width: 100,
        },
      ],
      headersDocs: [
        {
          title: "Documento",
        },
        {
          title: "Url",
        },
        {
          title: "Ações",
        },
      ],
      tipo_pessoa: ["JURIDICA", "FISICA"],
      comissoes: [
        { text: "3%", value: "3" },
        { text: "Regra Personalizada", value: "1" },
      ],
    };
  },

  methods: {
    goToPDV(type, data) {
      const { post } = this.$axios;
      const { LISTAR_EQUIPAMENTO_DISPONIVEL } = this.ENDPOINTS;
      const {
        idponto_venda,
        tipo_pessoa,
        razao_social,
        cnpj,
        representante_nome,
        representante_cpf,
        representante_rg,
        representante_rg_orgao,
        representante_email,
        celular,
        nidregional,
        status,
        idtipo_pdv,
        end_cep,
        end_estado,
        end_cidade,
        end_bairro,
        end_logradouro,
        end_complemento,
        comissao_porcentagem_custom,
        observacoes,
        nome_titular,
        banco,
        agencia,
        tipo_conta,
        numero_conta,
        digito_conta,
        pdf_documento,
        pdf_contrato_social,
        pdf_comprovante_endereco,
        pdf_procuracao,
        rede_vendas,
        link_vendas,
        senha_supervisor,
        loja,
      } = data;
      this.$pointOfSale.actionType = type;

      let param = idponto_venda !== undefined ? idponto_venda : "empty";

      post(LISTAR_EQUIPAMENTO_DISPONIVEL + param, { listar_vazios: true })
        .then(response => {
          let equips = [];
          if (response) {
            response.forEach(equip => {
              if (equip.idponto_venda !== "") {
                equips.push(equip);
              }
            });
            this.$pointOfSale.cadastro.equipamentos.equipamentos_array = equips;
            this.$pointOfSale.lista_equipamentos = response;
          }
        })
        .catch(() => {
          throw new Error("Erro ao listar equipamentos");
        });

      if (type === "editar" && data) {
        this.$router.push({
          name: "salePointSettings",
          params: {
            type: "editar",
          },
        }),
          // this.$axios.rota("/vendas/ponto-de-venda/editar");
          (this.$pointOfSale.cadastro.idpdv = idponto_venda);

        // dados cadastrais
        this.$pointOfSale.cadastro.dados_cadastrais.pessoa =
          tipo_pessoa || "JURIDICA";
        this.$pointOfSale.cadastro.dados_cadastrais.razao_social =
          razao_social || "";
        this.$pointOfSale.cadastro.dados_cadastrais.cnpj = cnpj || "";
        this.$pointOfSale.cadastro.dados_cadastrais.nome_representante =
          representante_nome || "";
        this.$pointOfSale.cadastro.dados_cadastrais.cpf =
          representante_cpf || "";
        this.$pointOfSale.cadastro.dados_cadastrais.rg = representante_rg || "";
        this.$pointOfSale.cadastro.dados_cadastrais.rg_orgao =
          representante_rg_orgao || "";
        this.$pointOfSale.cadastro.dados_cadastrais.email =
          representante_email || "";
        this.$pointOfSale.cadastro.dados_cadastrais.celular = celular || "";
        this.$pointOfSale.cadastro.dados_cadastrais.regional =
          nidregional || "";
        this.$pointOfSale.cadastro.dados_cadastrais.status = status || "ATIVO";
        this.$pointOfSale.cadastro.dados_cadastrais.tipo_ponto_venda =
          idtipo_pdv || "";
        this.$pointOfSale.cadastro.dados_cadastrais.cep = end_cep || "";
        this.$pointOfSale.cadastro.dados_cadastrais.estado = end_estado || "";
        this.$pointOfSale.cadastro.dados_cadastrais.cidade = end_cidade || "";
        this.$pointOfSale.cadastro.dados_cadastrais.bairro = end_bairro || "";
        this.$pointOfSale.cadastro.dados_cadastrais.logradouro =
          end_logradouro || "";
        this.$pointOfSale.cadastro.dados_cadastrais.complemento =
          end_complemento || "";

        // comissao
        this.$pointOfSale.cadastro.comissao_antecipacao.comissao =
          String(data.comissao) || "3";
        this.$pointOfSale.cadastro.comissao_antecipacao.porcentagem_customizada =
          comissao_porcentagem_custom || 0;
        this.$pointOfSale.cadastro.comissao_antecipacao.observacoes =
          observacoes || "";

        // dados bancarios
        this.$pointOfSale.cadastro.dados_bancarios.nome_titular =
          nome_titular || "";
        this.$pointOfSale.cadastro.dados_bancarios.banco = banco || "";
        this.$pointOfSale.cadastro.dados_bancarios.agencia = agencia || "";
        this.$pointOfSale.cadastro.dados_bancarios.tipo_de_conta =
          tipo_conta || "CORRENTE";
        this.$pointOfSale.cadastro.dados_bancarios.numero_conta =
          numero_conta || "";
        this.$pointOfSale.cadastro.dados_bancarios.digito = digito_conta || "";

        // documentos
        if (tipo_pessoa == "JURIDICA") {
          let documento = [];

          if (pdf_documento) {
            documento.push({ pdf_documento: pdf_documento });
            this.$pointOfSale.cadastro.documentos.documento_array_pj =
              documento;
          }

          if (pdf_contrato_social) {
            documento.push({ pdf_contrato_social: pdf_contrato_social });
            this.$pointOfSale.cadastro.documentos.documento_array_pj =
              documento;
          }

          if (pdf_comprovante_endereco) {
            documento.push({
              pdf_comprovante_endereco: pdf_comprovante_endereco,
            });
            this.$pointOfSale.cadastro.documentos.documento_array_pj =
              documento;
          }

          if (pdf_procuracao) {
            documento.push({ pdf_procuracao: pdf_procuracao });
            this.$pointOfSale.cadastro.documentos.documento_array_pj =
              documento;
          }
        } else {
          let documento = [];

          if (pdf_documento) {
            documento.push({ pdf_documento: pdf_documento });
            this.$pointOfSale.cadastro.documentos.documento_array_pf =
              documento;
          }

          if (pdf_contrato_social) {
            documento.push({ pdf_contrato_social: pdf_contrato_social });
            this.$pointOfSale.cadastro.documentos.documento_array_pf =
              documento;
          }

          if (pdf_comprovante_endereco) {
            documento.push({
              pdf_comprovante_endereco: pdf_comprovante_endereco,
            });
            this.$pointOfSale.cadastro.documentos.documento_array_pf =
              documento;
          }

          if (pdf_procuracao) {
            documento.push({ pdf_procuracao: pdf_procuracao });
            this.$pointOfSale.cadastro.documentos.documento_array_pf =
              documento;
          }
        }

        // equipamentos
        this.$pointOfSale.cadastro.equipamentos.rede_vendas =
          rede_vendas || "PRIVADA";
        this.$pointOfSale.cadastro.equipamentos.hasSupervisorPass =
          senha_supervisor;
        this.$pointOfSale.cadastro.equipamentos.link_venda = link_vendas || "";
        this.$pointOfSale.cadastro.equipamentos.selectedStore = Number(loja);
        return;
      }

      this.$router.push({
        name: "salePointSettings",
        params: {
          type: "cadastrar",
        },
      });
    },
    getDOC(file) {
      const self = this;
      var reader = new FileReader();
      reader.onload = e =>
        (self.$pointOfSale.cadastro.documentos.documento_upload.doc =
          e.target.result);
      reader.readAsDataURL(file);
      reader.onerror = function (error) {
        console.log("Error: ", error);
      };
    },
    uploadDOC(file) {
      if (this.$pointOfSale.cadastro.documentos.documento == "") {
        this.$config.alert(
          "Selecione o tipo de documento!",
          this.$config.dados.errorColor
        );
        this.$pointOfSale.cadastro.documentos.error.documento =
          "Selecione o tipo de documento!";
        return;
      }

      if (this.$pointOfSale.cadastro.documentos.documento_upload.doc == null) {
        this.$config.alert(
          "Importe algum documento!",
          this.$config.dados.errorColor
        );
        return;
      }

      this.$pointOfSale.cadastro.documentos.loading_documento = true;
      this.$axios
        .post(this.ENDPOINTS.UPLOAD_DOCUMENT_POINT_OF_SALE, {
          doc_base64: file,
          idponto_venda:
            this.$pointOfSale.lojaAddOrEdit == "new" &&
            this.$pointOfSale.cadastro.dados_cadastrais.pessoa === "FISICA"
              ? this.$pointOfSale.cadastro.documentos.documento_array_pf
                  .length === 0
              : this.$pointOfSale.cadastro.documentos.documento_array_pj
                  .length === 0
              ? ""
              : this.$pointOfSale.cadastro.idpdv,
          campo: this.$pointOfSale.cadastro.documentos.documento,
        })
        .then(response => {
          if (response) {
            let object = {};

            if (
              this.$pointOfSale.cadastro.dados_cadastrais.pessoa === "FISICA"
            ) {
              if (
                this.$pointOfSale.actionType == "new" &&
                this.$pointOfSale.cadastro.documentos.documento_array_pf
                  .length == 0
              ) {
                this.$pointOfSale.cadastro.idpdv = response.idponto_venda;
              }

              object[this.$pointOfSale.cadastro.documentos.documento] =
                response.url_s3;
              this.$pointOfSale.cadastro.documentos.documento_array_pf.push(
                object
              );
              this.$pointOfSale.cadastro.documentos.loading_documento = false;
            } else {
              if (
                this.$pointOfSale.actionType == "new" &&
                this.$pointOfSale.cadastro.documentos.documento_array_pj
                  .length == 0
              ) {
                this.$pointOfSale.cadastro.idpdv = response.idponto_venda;
              }

              object[this.$pointOfSale.cadastro.documentos.documento] =
                response.url_s3;
              this.$pointOfSale.cadastro.documentos.documento_array_pj.push(
                object
              );
              this.$pointOfSale.cadastro.documentos.loading_documento = false;
            }

            (this.$pointOfSale.cadastro.documentos.documento = ""),
              (this.$pointOfSale.cadastro.documentos.documento_upload.doc =
                null);
            delete this.$pointOfSale.cadastro.documentos.documento_upload
              .object;
          }

          this.$pointOfSale.cadastro.documentos.loading_documento = false;
        })
        .catch(error => {
          this.$pointOfSale.cadastro.documentos.loading_documento = false;
          throw new Error(error);
        });
    },
    clearDOC() {
      this.$pointOfSale.cadastro.documentos.documento_upload.doc = null;
    },
    previewImage(doc) {
      document.getElementsByClassName(
        "modal-body-visualizar-imagem"
      )[0].style.display = "flex";
      this.$pointOfSale.visualizarImagem = doc;
    },
  },
};
